// error constants
export const NO_ERROR = 0;
export const NO_ERROR_2 = 2;
export const FB_ID_NOT_REGISTERED = 100;
export const WHATSAPP_USER_NOT_VERIFIED = 1;
export const UNAUTHORIZED = 409;
export const UNAUTHORIZED_MESSAGE = "Unauthorised Access";
export const LOW_WALLET_BALANCE = 12;